module.exports = __webpack_public_path__ + "img/Ignite.ff728994.png";